<template>
  <div class="submitSuccess">
    <div class="submitSuccess_container">
      <div class="personalMessage_header">
        <div class="personalMessage_header_left">
          <div class="personalMessage_schoolIcon">
            <img alt="" src="../assets/imgs/schoolIcon.png">
          </div>
          <div class="personalMessage_systemName">学生信息采集系统</div>
        </div>
        <div class="personalMessage_header_right">
        </div>
      </div>
      <div class="submitSuccess_content">
        <div class="submitSuccess_icon">
          <i class="el-icon-success"></i>
        </div>
        <div class="submitSuccess_tip">提交成功</div>
        <div class="submitSuccess_operate">
          <el-button class="purple" type="primary" @click="checkFillMessage">查看填写信息</el-button>
          <el-button class="default" @click="exit">退出系统</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'element-ui'
import { decryptWithSignature } from "@/util";

Vue.use(Button)
export default {
  name: 'submitSuccess',
  data () {
    return {}
  },
  methods: {
    checkFillMessage () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      const map = {

        VUE_APP_BATCHID_ART: '/art',

        VUE_APP_BATCHID_SCIENCE: '/science',

        VUE_APP_BATCHID_SPORT: '/sport'
      }
      this.$router.push(
        {
          path: map[decryptWithSignature(batchId)],
          query: this.$route.query
        }
      )
    },
    exit () {
      this.$router.push(
        {
          path: '/'
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.submitSuccess_container {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  color: rgba($color: #000000, $alpha: .85);

  .personalMessage_header {
    height: 125px;
    background-image: url('../assets/imgs/header.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .personalMessage_header_left {
      display: flex;
      justify-content: space-between;

      .personalMessage_schoolIcon {
        padding-left: 10px;
      }

      .personalMessage_systemName {
        display: inline-block;
        font-size: 25px;
        line-height: 81px;
        margin-left: 16px;
        font-weight: bold;
        color: #6C2463;
      }
    }
  }

  .submitSuccess_content {
    height: 500px;
    padding-top: 70px;
    text-align: center;

    .el-icon-success {
      font-size: 70px;
      color: #52C41A;
    }

    .submitSuccess_tip {
      font-size: 24px;
      line-height: 32px;
      margin: 20px 0 10px;
    }

    .submitSuccess_subtip {
      line-height: 22px;
      color: rgba($color: #000000, $alpha: .45);
    }

    .submitSuccess_identity_message {
      margin: 20px auto;
      padding: 20px 30px;
      text-align: left;
      width: 464px;
      height: 124px;
      border: 1px dotted rgba(0, 0, 0, 0.15);

      p {
        margin-bottom: 8px;
      }
    }

    .submitSuccess_operate {
      margin-top: 20px;

      .el-button {
        margin: 0 20px;
      }
    }
  }
}
</style>
<style lang="scss">
.purple {
  background-color: #1890FF !important;
  border-color: #1890FF !important;

  &:hover {
    background-color: #1890FF;
    border-color: #1890FF;
    color: #fff;
  }
}

.default:hover {
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
}
</style>
